import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { useWindowSize } from '@app/hooks';
import { useProductCategoriesHeader } from '@app/pages/Warehouses/ProductCategories/hooks';

export const ProductCategoriesHeader = () => {
  const { goToAddCategory, IsProductCategoryCreate } =
    useProductCategoriesHeader();
  const { isMobile } = useWindowSize();

  if (!IsProductCategoryCreate) {
    return null;
  }

  return (
    <Button
      className={isMobile ? 'full-width' : ''}
      type="primary"
      onClick={goToAddCategory}
      icon={<PlusOutlined />}
    >
      Добавить категорию
    </Button>
  );
};
